import { ChangeDetectionStrategy, Component } from '@angular/core';

import { LoadingSkeletonComponent } from '@shared/components/loading-skeleton';

@Component({
  selector: 'app-ai-message-list-loading-skeleton',
  imports: [LoadingSkeletonComponent],
  templateUrl: './ai-message-list-loading-skeleton.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'flex flex-col grow gap-3' },
})
export class AiMessageListLoadingSkeletonComponent {}
